import config from './config';
const partnerTrialPage = () => {
	// eslint-disable-next-line @wordpress/no-global-event-listener
	document.addEventListener('DOMContentLoaded', () => {
		const env = config();
		const partnerCheckoutURL = `${env.appDashboardUrl}/checkout-trial/${window.location.search}`;
		document.querySelectorAll('.partner-trial-cta a, a.partner-trial-cta').forEach((action) => {
			action.href = partnerCheckoutURL;
		});

		// select all the element having class partner-trial-cta which does contains an anchor
		// tag and attach click event listener for redirecting
		try {
			document.querySelectorAll('.partner-trial-cta:has(:not(a))').forEach((e) => {
				e.addEventListener('click', () => {
					window.location = partnerCheckoutURL;
				});
			});
		} catch (err) {
			// eslint-disable-next-line no-console
			console.log(err);
		}
	});
};

export default partnerTrialPage;
